export const CASE_MANAGEMENT_PRODUCT_NAME = 'Case Management';
export const INTAKE_MANAGEMENT_PRODUCT_NAME = 'Intake Management';
export const FILE_RESTRICTIONS_PRODUCT_NAME = 'Restrictions';
export const COMPASS_PRODUCT_NAME = 'Compass';
export const CASE_MANAGEMENT_INTAKE_WINDOW_NAME = 'INTAKE';
export const FSCD_PRODUCT_NAME = 'Family Support for Children with Disabilities';
export const AUTH_MANAGEMENT_PRODUCT_NAME = 'Users & roles';
